module.exports = __webpack_public_path__ + "static/media/icon_time.ba29b243.svg";